// src/config/languageConfig.ts

export interface LanguageOption {
    code: 'en-US' | 'zh-TW';
    name: string;
    short: string;
}

export const languages: LanguageOption[] = [
    { code: 'en-US', name: 'English', short: 'EN' },
    { code: 'zh-TW', name: '繁體中文', short: '繁' },
];